import { db, database, message } from '../../firebase'
import store from '../../store'

const isEcommercePlatform = store.getters.isEcommercePlatform

export const Chatrooms = db.collection('CHATROOMS')

export const getRoomsByUserId = (userId) => (
    Chatrooms
        .where('users', 'array-contains', userId)
        .orderBy('lastMessageDate', 'desc')
)

export const getRoomsByCampaigns = (campaignsIds) => (
    Chatrooms
        .where('campaigns', 'array-contains', campaignsIds)
)

export const getRoomsByShops = (shopsIds) => (
    Chatrooms
        .where('shops', 'array-contains', shopsIds)
)

export const getRoomById = (roomId) => (
    Chatrooms.doc(roomId)
)

export const createRoom = (data) => Chatrooms.add(data)

export const getMessages = (roomId) =>  {
    const messages = isEcommercePlatform ? 'shopsMessages' :'messages' 
    return (
        database
            .ref(`${messages}/${roomId}`)
            .orderByChild('createdAt')
    )
}

export const saveMessage = ({
    roomId,
    userId,
    username,
    message: content,
}) => message({ roomId, userId, username, message: content, isShop: isEcommercePlatform})

export const updateRoomLastMessage = ({
    roomId,
    userId,
    message,
}) => (
    Chatrooms
        .doc(roomId)
        .update({
            lastMessageDate: new Date().getTime(),
            lastMessage: {
                message,
                seen: false,
                uid: userId
            },
        })
)

export const notifyPartner = ({
    partnerId,
    roomId,
}) => (
    database
        .ref(`unreadMessages/${partnerId}`)
        .push({ chatroom: roomId })
)

export const markRoomAsSeen = (roomId) => (
    Chatrooms
        .doc(roomId)
        .update({ 'lastMessage.seen': true })
)

export const markNotificationsAsRead = (userId, id) => {
    return database
        .ref(`unreadMessages/${userId}/${id}`)
        .remove()
}

export const markAllMessagesAsRead = (userId, id) => {
    return database
        .ref(`unreadMessages/${userId}`)
        .remove()
}